// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Decode_Combinators = require("../Data.Argonaut.Decode.Combinators/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Effect_Unsafe = require("../Effect.Unsafe/index.js");
var Lunarbox_Data_Dataflow_Runtime_ValueMap = require("../Lunarbox.Data.Dataflow.Runtime.ValueMap/index.js");
var Lunarbox_Data_Editor_FunctionName = require("../Lunarbox.Data.Editor.FunctionName/index.js");
var Lunarbox_Data_Editor_Location = require("../Lunarbox.Data.Editor.Location/index.js");
var Lunarbox_Data_Editor_Project = require("../Lunarbox.Data.Editor.Project/index.js");
var Lunarbox_Data_Editor_State = require("../Lunarbox.Data.Editor.State/index.js");
var Lunarbox_Foreign_Render = require("../Lunarbox.Foreign.Render/index.js");
var Record = require("../Record/index.js");
var stateToJson = function (v) {
    var save = {
        name: v.name,
        isExample: v.isExample,
        visible: v.isVisible,
        metadata: {
            nodeCount: Lunarbox_Data_Editor_State.nodeCount(v),
            functionCount: Lunarbox_Data_Editor_State.visualFunctionCount(v)
        },
        project: {
            project: v.project,
            nextId: v.nextId,
            geometries: v.geometries,
            runtimeOverwrites: v.runtimeOverwrites,
            currentFunction: v.currentFunction
        }
    };
    return Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "nodeCount";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "functionCount";
    }))())())(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Lunarbox_Data_Editor_FunctionName.encodeJsonFunctionName)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeMap(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(Lunarbox_Data_Editor_FunctionName.encodeJsonFunctionName)(Lunarbox_Foreign_Render.encodeJsonGeometryCache))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Lunarbox_Data_Editor_Project.encodeJsonProject)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Lunarbox_Data_Dataflow_Runtime_ValueMap.encodeJsonValueMap(Lunarbox_Data_Editor_Location.encodeJsonLocation)(Lunarbox_Data_Editor_Location.ordLocation))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "runtimeOverwrites";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "project";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "nextId";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "geometries";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "currentFunction";
    }))())())(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "visible";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "project";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "name";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "metadata";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "isExample";
    }))())())(save);
};
var jsonToState = function (json) {
    return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeForeignObject(Data_Argonaut_Decode_Class.decodeJsonJson))(json))(function (obj) {
        return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonString)(obj)("name"))(function (v) {
            return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonBoolean)(obj)("isExample"))(function (v1) {
                return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonBoolean)(obj)("visible"))(function (v2) {
                    return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Lunarbox_Data_Editor_FunctionName.decodeJsonFunctionName)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeMap(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(Lunarbox_Data_Editor_FunctionName.decodeJsonFunctionName)(Lunarbox_Foreign_Render.decodeJsonGeometryCache))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Lunarbox_Data_Editor_Project.decodeJsonProject)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Lunarbox_Data_Dataflow_Runtime_ValueMap.decodeJsonValueMap(Lunarbox_Data_Editor_Location.decodeJsonLocation)(Lunarbox_Data_Editor_Location.ordLocation))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                        return "runtimeOverwrites";
                    }))()())(new Data_Symbol.IsSymbol(function () {
                        return "project";
                    }))()())(new Data_Symbol.IsSymbol(function () {
                        return "nextId";
                    }))()())(new Data_Symbol.IsSymbol(function () {
                        return "geometries";
                    }))()())(new Data_Symbol.IsSymbol(function () {
                        return "currentFunction";
                    }))()())())(obj)("project"))(function (v3) {
                        var recivedData = Record.merge()()({
                            name: v,
                            isExample: v1,
                            isVisible: v2
                        })(v3);
                        var baseState = Record.merge()()(recivedData)(Effect_Unsafe.unsafePerformEffect(Lunarbox_Data_Editor_State.emptyState(Effect_Class.monadEffectEffect)));
                        return Control_Applicative.pure(Data_Either.applicativeEither)(baseState);
                    });
                });
            });
        });
    });
};
module.exports = {
    stateToJson: stateToJson,
    jsonToState: jsonToState
};
